const baseUrl = __BEN_VSA_SERVICE_URL__;

export const ApiEndpoints = {
  EmployeeList: `${baseUrl}/api/v1/Security/EmployeeList`,
  AddRoleAlias: `${baseUrl}/api/v1/Security/AddRole`,
  RemoveRoleAlias: `${baseUrl}/api/v1/Security/RemoveRole`,
} as const;

const errorMsg = (name: string) => `Something went wrong while retrieving ${name}.`;

export const Messages = {
  EmployeeList_Error_Message: errorMsg('Employee list'),
  AddRole_Error_Message: errorMsg('role assignment'),
  RemoveRole_Error_Message: errorMsg('role removal'),
  SecurityGroups_Error_Message: errorMsg('security groups'),
} as const;

export const RoleNames = ['Admin', 'Hr', 'HrForHr'] as const;

export const BuildOnceAppName = 'BuildOnceTest';

export const SearchMinChars = 2;

// Security page UI constants
export const SECURITY_HEADING_ID = 'securityHeading';
export const ALIAS_STATUS_ID = 'aliasStatus';

export const UI_STRINGS = {
  securityTitle: 'Security',
  aliasPlaceholder: 'Select Alias',
  aliasAriaLabel: 'Alias',
  rolePlaceholder: 'Select Role',
  roleAriaLabel: 'Role',
  clearTitle: 'Clear',
  clearAriaLabel: 'Clear selection',
  assignText: 'Assign',
  assignAriaLabel: 'Assign role',
  removeText: 'Remove',
  removeAriaLabel: 'Remove role',
  searching: 'Searching…',
  employeeNotFound: 'Employee not found',
} as const;

export const OPERATION_MESSAGES = {
  assigning: 'Assigning role…',
  removing: 'Removing role…',
  assignSuccess: 'Role assigned successfully.',
  removeSuccess: 'Role removed successfully.',
  assignFailed: 'Failed to assign role.',
  removeFailed: 'Failed to remove role.',
  noMatchingAlias: 'No matching alias found for the specified role.',
  genericErrorPhrase: 'something went wrong',
} as const;

// General app constants (consolidated from utils/constants.ts)
export const RESIZE = 'resize';
export const KEYDOWN = 'keydown';
export const CLICK = 'click';
export const DEFAULT_PAGE_SIZE = 10;
export const MAX_REPORT_SIZE = 1000000;
export const HIDDEN = 'hidden';